const React = require('react');

const Plus = () => (
  <svg className="button-icon" viewBox="0 0 16 16">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.8">
      <path
        className="button-icon__path"
        d="M8.599,2.00067031 L8.599,7.40067031 L13.999,7.40067031 L13.999,8.60067031 L8.599,8.60067031 L8.599,14.0006703 L7.399,14.0006703 L7.399,8.60067031 L1.999,8.60067031 L1.999,7.40067031 L7.399,7.40067031 L7.399,2.00067031 L8.599,2.00067031 Z"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

module.exports = Plus;
